var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("route.ordersbymonth") } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["STORE_DETAIL_MONTH"] },
                expression: "{pageName, list: ['STORE_DETAIL_MONTH']}",
              },
            ],
            attrs: { slot: "header-right" },
            slot: "header-right",
          },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.toOrderDetails },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("route.storedetaillist")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              { attrs: { size: "small", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("sfe.reportModule.month") },
                          },
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "month",
                                clearable: false,
                                format: "yyyy-MM",
                                "value-format": "yyyyMM",
                              },
                              on: { change: _vm.fetchListData },
                              model: {
                                value: _vm.queryDate,
                                callback: function ($$v) {
                                  _vm.queryDate = $$v
                                },
                                expression: "queryDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "main-table-container" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  stripe: "",
                  "highlight-current-row": "",
                  "tooltip-effect": "dark",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "brand",
                    label: _vm.$t("sfe.reportModule.ordersTable.brand"),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "tppCount",
                    label: _vm.$t("sfe.reportModule.ordersTable.tpp"),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(_vm._s(_vm.paddingNum(scope.row.tppCount))),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "salesTargetQty",
                    label: _vm.$t("sfe.reportModule.ordersTable.orderNums"),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(_vm.paddingNum(scope.row.salesTargetQty))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderQty",
                    label: _vm.$t("sfe.reportModule.ordersTable.orderQuat"),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(_vm._s(_vm.paddingNum(scope.row.orderQty))),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "confirmedQty",
                    label: _vm.$t("sfe.reportModule.ordersTable.confirmQuat"),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(_vm.paddingNum(scope.row.confirmedQty))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unMonthConfirmedQty",
                    label: _vm.$t(
                      "sfe.reportModule.ordersTable.waitConfirmQuat"
                    ),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.paddingNum(scope.row.unMonthConfirmedQty)
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "unThreeMonthConfirmedQty",
                    label: _vm.$t(
                      "sfe.reportModule.ordersTable.historyConfirmQuat"
                    ),
                    align: "center",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.paddingNum(scope.row.unThreeMonthConfirmedQty)
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }